<template>
  <div class="container">
    <p>
      Ask the customer if they need to review the offer or if they prefer us to handle everything.
    </p>
    <el-row type="flex" justify="space-around" :gutter="9" class="">
      <el-col :span="9">
        <el-container class="card">
          <div @click="action('no')" tag="span" class="card-link">
            <p class="heading">
              <b>review offer</b>
            </p>
            <p>
              If the swapper wants to be notified when their offer is ready and come back to review it, they can then choose to accept credit or cash for some or all items. 
            </p>
          </div>
        </el-container>
        
      </el-col>
      <el-col :span="9">
        <el-container class="card">
          <div @click="action('yes')" tag="span" class="card-link">
            <p class="heading">
              <b>e-signature</b>
            </p>
            <p>
              If the swapper wants to be notified when their offer is ready and come back to review it, they can then choose to accept credit or cash for some or all items.
            </p>
          </div>
        </el-container>
       
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '../components/BaseCard.vue';

export default {
  name: 'DropoffDecisionPage',
  methods: {
    action(choice) {
      if (choice === "yes"){
        this.$store.dispatch('shopper/setDonateRemaining', true);
        
        // add e-signature tag tp selected tags
        var tags = this.$store.getters['tags/getTags'];
        const eSignatureTag = tags.find((tag) => tag.key === 'E_SIGNATURE');
        this.$store.dispatch('tags/addSelectedTag', eSignatureTag);

      } else {
        this.$store.dispatch('shopper/setDonateRemaining', false);
        
        // remove the e-signature tag from tags selected
        var tags = this.$store.getters['tags/getTags'];
        tags.forEach(tag => {
          if (tag.key === 'E_SIGNATURE') {
            tag.hidden = true;
          }
        });
        this.$store.dispatch('tags/setTags', tags);
      }
      this.$router.push('/bin_number');
    }
  }
};
</script>

<style scoped>
.container {
  padding: 0 6vw 0 6vw;
}

.container > p {
  font-size: 1.2em;
}

.card-link {
  font-size: 18px;
  display: flex;
  flex-direction: column;
}
</style>
